import SectionHeading from "@/pages/home/components/SectionHeading";
import { communityPosts } from "@/mocks/home";

export default function CommunitySection() {
  return (
    <section id="community" className="hl-anchor w-full bg-background-50">
      <div className="px-4 py-14 md:px-6 md:py-16 lg:px-8">
        <SectionHeading
          eyebrow="Community"
          title="黑料51讨论圈 · 瓜友热议"
          desc="这里是观点的交锋现场，也是互补线索的地方。发言请附上依据，讲清楚比讲大声更重要。"
          actionLabel="进入讨论圈"
        />

        <div className="mt-10 grid gap-5 lg:grid-cols-12">
          <div className="grid gap-5 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-2">
            {communityPosts.map((post) => (
              <article
                key={post.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-base font-bold text-background-50">
                    {post.nickname.slice(0, 1)}
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-bold text-foreground-950">{post.nickname}</p>
                    <p className="text-[11px] text-foreground-500">
                      {post.role} · {post.time}
                    </p>
                  </div>
                </div>

                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  {post.content}
                </p>

                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
                    #{post.tag}
                  </span>
                  <div className="flex items-center gap-4">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-thumb-up-line text-sm" />
                      </span>
                      {post.likes}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-chat-3-line text-sm" />
                      </span>
                      {post.replies}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <aside className="lg:col-span-4">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-foreground-950 p-6">
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-100">
                <span className="hl-pulse-dot h-1.5 w-1.5 rounded-full bg-accent-400" />
                讨论圈实时在线 3,182 人
              </span>
              <h3 className="mt-5 font-heading text-xl font-black leading-snug text-background-50">
                把你的线索
                <br />
                摆到桌面上
              </h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-background-100/70">
                一条时间戳、一张前后对比图、一段原始回放，都可能成为别人拼图里缺的那一块。
                黑料51吃瓜社区欢迎有理有据的发言，也欢迎冷静的反对意见。
              </p>
              <a
                href="#join"
                className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-add-line text-base" />
                </span>
                发布新话题
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}